//export const GLOBAL_URL = 'http://52.66.98.251:9511'
// export const GLOBAL_URL = 'https://api-ae-obc.oncobench360.com'

//  export const biomarkercolors = ['#2E1D51','#352258','#3C2760','#432D67','#4B336F','#523976','#5A407E','#614685','#694C8C', '#705393',
//     '#78599B','#7F60A2','#8766A9','#8E6DB1',  '#9673B8']
export const GLOBAL_URL = process.env.REACT_APP_ONCOVIZ_UI_V2_API_BASE_URL;

export const biomarkercolors = [
  "#2E1D51",
  "#352258",
  "#3C2760",
  "#432D67",
  "#4B336F",
  "#523976",
  "#5A407E",
  "#614685",
  "#694C8C",
  "#705393",
  "#78599B",
  "#7F60A2",
  "#8766A9",
  "#8E6DB1",
  "#9673B8",
  "#9E79BF",
  "#A67FC6",
  "#AE85CD",
  "#B78BD4",
  "#BF91DB",
  "#C797E2",
  "#CF9DE9",
  "#D8A3F0",
  "#E0A9F7",
  "#E8AFFE",
];
export const colors1 = [
  "#0A3045",
  "#174B67",
  "#296789",
  "#3F85AB",
  "#5BA5CD",
  "#7CC7EF",
  "#9FDDFE",
  "#BBE7FF",
  "#D7F1FF",
  "#F2FAFF",
];
export const colors3 = [
  "#705E3A",
  "#94866B",
  "#B7AE9C",
  "#FACE79",
  "#FFDEA3",
  "#261900",
  "#332300",
  "#402D00",
  "#4E3800",
  "#5D4200",
  "#6B4D00",
  "#79590C",
  "#87651A",
  "#947226",
  "#A27E31",
  "#B18B3D",
  "#BF9849",
  "#CDA554",
  "#DCB360",
  "#EBC16C",
  "#FACE79",
  "#FFDEA3",
  "#FFE5B8",
  "#FFEBCC",
  "#FFEFD6",
  "#FFF2DF",
  "#FFF8F2",
  "#FFF8F2",
  "#FFFFFF",
];
export const colors2 = [
  "#000000",
  "#00040B",
  "#000813",
  "#000F1E",
  "#001223",
  "#001527",
  "#00192D",
  "#001D33",
  "#002844",
  "#003354",
  "#003E66",
  "#004A78",
  "#00568A",
  "#00629D",
  "#006FB0",
  "#007CC4",
  "#0089D8",
  "#0197ED",
  "#2AA4FB",
  "#56B1FF",
  "#7ABEFF",
  "#99CBFF",
  "#B4D8FF",
  "#CFE5FF",
  "#E3EFFF",
  "#EDF4FF",
];

export const colors9 = ["#1E4E69", "#3E6A81", "#5E869A", "#7FA2B2", "#9FBFCC"];
export const colors4 = [
  "#1E4E69",
  "#22566F",
  "#265E75",
  "#2B667B",
  "#2F6E81",
  "#347687",
  "#397E8D",
  "#3E8693",
  "#438E99",
  "#48969F",
  "#4E9EA5",
  "#53A6AB",
  "#58AEB1",
  "#5DB6B7",
  "#62BEBD",
  "#68C6C3",
  "#6DCECA",
  "#73D6D0",
  "#78DEd6",
  "#7EE6DC",
  "#84ECE1",
  "#8AF2E7",
  "#90F7ED",
  "#97FBF2",
  "#9DFFF8",
  "#A3FFF9",
  "#AAFFFB",
  "#B0FFFD",
  "#B6FFFF",
  "#BCFFFF",
];

export const colors10 = ["#174B67", "#51788D", "#8AA4B2"];
export const colors11 = ["#4A3C76", "#776C98", "#A49CBA"];
export const colors12 = ["#705E3A", "#94866B", "#867248"];

export const colors5 = [
  "#27184A",
  "#3A2C5C",
  "#4E4170",
  "#635786",
  "#7A6D9B",
  "#9383AF",
  "#AC9AC4",
  "#C6B1D8",
];
export const colors6 = [
  "#705E3A",
  "#94866B",
  "#B7AE9C",
  "#867248",
  "#9D8656",
  "#B49B67",
  "#CBB078",
  "#E2C58A",
  "#F3D8A4",
  "#FBEAC4",
];
export const colors7 = [
  "#705E3A",
  "#867248",
  "#9D8656",
  "#B49B67",
  "#CBB078",
  "#E2C58A",
  "#F3D8A4",
  "#FBEAC4",
];
export const colors8 = [
  "#1E4E69",
  "#58869B",
  "#76A1B3",
  "#93BCCB",
  "#B0D6E2",
  "#CDE9F0",
  "#E5F4F9",
  "#2F6178",
  "#3C6A83",
  "#4E7F94",
  "#58869B",
  "#6996A8",
  "#76A1B3",
  "#85AEC0",
  "#93BCCB",
  "#A2CAD6",
  "#B0D6E2",
  "#BEE1EB",
  "#CDE9F0",
  "#DAEFF5",
  "#E5F4F9",
  "#EFF9FC",
];
export const colors13 = [
  "#705E3A",
  "#867248",
  "#9D8656",
  "#B49B67",
  "#CBB078",
  "#E2C58A",
  "#F3D8A4",
  "#FBEAC4",
  "#FCF0D2",
  "#FCF4DC",
  "#FCF7E5",
  "#FDF9ED",
  "#FDFBF4",
  "#FAF0DA",
  "#F7E6C3",
  "#F5DBAD",
];

export const ColorValues = [
  {
    code: "#008000",
    name: "Low",
  },
  {
    code: "#ff0000",
    name: "High",
  },
  {
    code: "#008000",
    name: "Stable",
  },
  {
    code: "#ff0000",
    name: "Unstable",
  },
  {
    code: "#008000",
    name: "Positive",
  },
  {
    code: "#ff0000",
    name: "Negative",
  },
  {
    code: "#0000ff",
    name: "Male",
  },
  {
    code: "#ff1493",
    name: "Female",
  },
];
export const MSIColorValues = [
  {
    code: "#A8E6A3",
    name: "Low",
  },
  {
    code: "#DC3545",
    name: "High",
  },
  {
    code: "#28A745",
    name: "Stable",
  },
  {
    code: "#8B0000",
    name: "Unstable",
  },
  {
    code: "#FFC107",
    name: "Borderline",
  },
  {
    code: "#008000",
    name: "Positive",
  },
  {
    code: "#ff0000",
    name: "Negative",
  },
  {
    code: "#0000ff",
    name: "Male",
  },
  {
    code: "#ff1493",
    name: "Female",
  },
];
export const Top20BioColors = [
  {
    code: "#ff69b4",
    name: "Breast",
  },
  {
    code: "#c46210",
    name: "Kidney",
  },
  {
    code: "#32cd32",
    name: "Gallbladder",
  },
  {
    code: "#008000",
    name: "Liver and intrahepatic bile ducts",
  },
  {
    code: "#6495ed",
    name: "Thyroid",
  },
  {
    code: "#1e90ff",
    name: "Prostate",
  },
  {
    code: "#4169e1",
    name: "Stomach",
  },
  {
    code: "#9400d3",
    name: "Pancreas",
  },

  {
    code: "#a9a9a9",
    name: "Lung",
  },
  {
    code: "#696969",
    name: "Brain",
  },
  {
    code: "#4D4545",
    name: "Skin",
  },
  {
    code: "#006994",
    name: "Ovary",
  },
  {
    code: "#32cd32",
    name: "Lymphnode",
  },
  {
    code: "#ffdab9",
    name: "Uterus",
  },
  {
    code: "#0000ff",
    name: "Esophagus",
  },
  {
    code: "#71F170",
    name: "Large Intestine",
  },
  {
    code: "#FF8B8B",
    name: "Corpus Uteri",
  },
  {
    code: "#00D7E8",
    name: "Rectum",
  },
  {
    code: "#8b0000",
    name: " Other parts of tongue",
  },
  {
    code: "#ab4e52",
    name: "Unknown primary",
  },
  {
    code: "#ff0000",
    name: "Other and unspecified parts of mouth",
  },
  {
    code: "#EB455F",
    name: "Cervix Uteri",
  },
  {
    code: "#c30b4e",
    name: "Other and unspecified biliary tract",
  },
  {
    code: "#367588",
    name: "Urinary Bladder",
  },
  {
    code: "#BAF660",
    name: "Small Intestine",
  },
  {
    code: "#cd853f",
    name: "Connective, subcutaneous and other soft tissues",
  },
  {
    code: "#F473B9",
    name: "Rectosigmoid junction",
  },
  {
    code: "#8b4513",
    name: "Larynx",
  },
  {
    code: "#dc143c",
    name: "Other and unspecified major salivary gland",
  },
  {
    code: "#009698",
    name: "Hypopharynx",
  },
  {
    code: "#DFF6FF",
    name: "Intestinal tract",
  },
  {
    code: "#ffa500",
    name: "Lip",
  },
  {
    code: "#002147",
    name: "Bones, joints, and articular cartilage of the limb",
  },
  {
    code: "#2FA4FF",
    name: "Parotid gland",
  },
  {
    code: "#722f37",
    name: "Oropharynx",
  },
  {
    code: "#967117",
    name: "Anus and Anal canal",
  },
  {
    code: "#008b8b",
    name: "Ureter",
  },
  {
    code: "#022E57",
    name: "Renal pelvis",
  },
  {
    code: "#f94d00",
    name: "Palate",
  },
  {
    code: "0E3EDA",
    name: "Accessory sinuses",
  },
  {
    code: "#F9A11A",
    name: "Nasopharynx",
  },
  {
    code: "#EB4747",
    name: "Testis",
  },
  {
    code: "#FFDDEE",
    name: "Heart",
  },
  {
    code: "#7071F1",
    name: "Retroperitoneum and Peritoneum",
  },
  {
    code: "#5D8BF4",
    name: "Other and ill-defined sites in lip, oral cavity and pharynx",
  },
  {
    code: "#276678",
    name: "Cerebral Meninges",
  },
  {
    code: "#E2F91A",
    name: "Nasal cavity and middle ear",
  },
  {
    code: "#F9311A",
    name: "Fallopian tube and other regions",
  },
  {
    code: "#F69C60",
    name: "Vagina",
  },
  {
    code: "#F17071",
    name: "Adrenal gland",
  },
  {
    code: "#FFB300",
    name: "Floor of mouth",
  },
  {
    code: "#ABC9FF",
    name: "Other and unspecified urinary organs",
  },
  {
    code: "#E8FFC2",
    name: "Gum",
  },
  {
    code: "#00FFDD",
    name: "Thymus",
  },
  {
    code: "#0096AA",
    name: "Eye",
  },
  {
    code: "#FF8FCF",
    name: "Pyriform sinus",
  },
  {
    code: "#B5ECFE",
    name: "Base of Tongue",
  },
  {
    code: "#0D3B66",
    name: "Penis",
  },
  {
    code: "#57205F",
    name: "Tonsil",
  },
  {
    code: "#FF7D00",
    name: "Other endocrine glands",
  },
  {
    code: "#034078",
    name: "Bones, joints and articular cartilage of other/ unspecified sites",
  },
  {
    code: "#008178",
    name: "Other ill defined sites",
  },
];
export const CanSiteColors = [
  {
    code: "#ff69b4",
    name: "Breast",
  },
  {
    code: "#c46210",
    name: "Kidney",
  },
  {
    code: "#32cd32",
    name: "Gallbladder",
  },
  {
    code: "#008000",
    name: "Liver and intrahepatic bile ducts",
  },
  {
    code: "#6495ed",
    name: "Thyroid",
  },
  {
    code: "#1e90ff",
    name: "Prostate",
  },
  {
    code: "#4169e1",
    name: "Stomach",
  },
  {
    code: "#9400d3",
    name: "Pancreas",
  },

  {
    code: "#a9a9a9",
    name: "Lung",
  },
  {
    code: "#696969",
    name: "Brain",
  },
  {
    code: "#4D4545",
    name: "Skin",
  },
  {
    code: "#006994",
    name: "Ovary",
  },
  {
    code: "#32cd32",
    name: "Lymphnode",
  },
  {
    code: "#ffdab9",
    name: "Uterus",
  },
  {
    code: "#0000ff",
    name: "Esophagus",
  },
  {
    code: "#71F170",
    name: "Large Intestine",
  },
  {
    code: "#FF8B8B",
    name: "Corpus Uteri",
  },
];
export const CancerSiteColors = [
  {
    code: "#71F170",
    name: "Large Intestine",
  },
  {
    code: "#B6B9B8",
    name: "Brain",
  },
  {
    code: "#F06B9B",
    name: "Breast",
  },
  {
    code: "#F47338",
    name: "Kidney",
  },
  {
    code: "#F47338",
    name: "Endometrial",
  },
  {
    code: "#F9A11A",
    name: "Appendix",
  },
  {
    code: "#EDA53D",
    name: "Childhood",
  },
  {
    code: "#F6E760",
    name: "Bone",
  },
  {
    code: "#7AC243",
    name: "Non-Hodgkin lymphoma",
  },
  {
    code: "#01956D",
    name: "Liver and intrahepatic bile ducts",
  },
  {
    code: "#00A8B5",
    name: "Ovary",
  },
  {
    code: "#00A6B0",
    name: "Cervical",
  },
  {
    code: "#359DD7",
    name: "Colon",
  },
  {
    code: "#359DD7",
    name: "Stomach",
  },
  {
    code: "#C2B1D6",
    name: "Testicular",
  },
  {
    code: "#9C57A3",
    name: "Pancreatic",
  },
  {
    code: "#775CA1",
    name: "All Cancers",
  },
  {
    code: "#6A5EA8",
    name: "Hodgkin lymphoma",
  },
  {
    code: "#000000",
    name: "Skin",
  },
  {
    code: "#F69C60",
    name: "Lymphnode",
  },
  {
    code: "#BAF660",
    name: "Small Intestine",
  },
  {
    code: "#EB455F",
    name: "Cervix Uteri",
  },
  {
    code: "#FF8B8B",
    name: "Corpus Uteri",
  },
  {
    code: "#00A8B5",
    name: "Gallbladder",
  },
  {
    code: "#00D7E8",
    name: "Esophagus",
  },
  {
    code: "#629F33",
    name: "Pancreas",
  },
  {
    code: "#2B3467",
    name: "Prostate",
  },
  {
    code: "#005A8D",
    name: "Lung",
  },
  {
    code: "#F473B9",
    name: "Rectosigmoid junction",
  },
  {
    code: "#2FA4FF",
    name: "Parotid gland",
  },
];
export const colrs = [
  "#c30b4e",
  "#722f37",
  "#efcc00",
  "#967117",
  "#008b8b",
  "#367588",
  "#f94d00",
  "#cd853f",
  "#8b4513",
  "#8b0000",
  "#ab4e52",
  "#dc143c",
  "#ff0000",
  "#009698",
  "#ffa500",
  "#002147",
];
export const HospitalColor = [
  "#5373FF",
  "#425F5D",
  "#780000",
  "#3B4856",
  "#5F4B8B",
  "#669BBC",
  "#006D77",
  "#83C5BE",
  "#008178",
  "#034078",
  "#FF7D00",
  "#57205F",
  "#0D3B66",
  "#7AC243",
  "#B5ECFE",
  "#FF8FCF",
  "#0096AA",
];

export const COLORS = [
  "#775CA1",
  "#022E57",
  "#FFB300",
  "#BAD7E9",
  "#ABC9FF",
  "#F9A11A",
  "#FF8B8B",
  "#EB4747",
  "#E8FFC2",
  "#00FFDD",
  "#2FA4FF",
  "#FFDDEE",
  "#F473B9",
  "#0E3EDA",
  "#DFF6FF",
  "#5D8BF4",
  "#276678",
  "#E2F91A",
  "#F9311A",
  "#F69C60",
  "#F17071",
  "#7071F1",
  "#35D7C0",
  "#35D7C0",
  "#35D7C0",
  "#7AC243",
  "#00D7E8",
  "#005A8D",
];

export const tmbColor = ["#EB455F", "#323D7B", "#BAD7E9"];
export const DrugsCountColor = [
  {
    code: "#EB455F",
    name: "Pembrolizumab",
  },
  {
    code: "#BAD7E9",
    name: "Nivolumab",
  },
  {
    code: "#323D7B",
    name: "Cemiplimab",
  },
  {
    code: "#775CA1",
    name: "Atezolizumab",
  },
  {
    code: "#006D77",
    name: "Avelumab",
  },
  {
    code: "#83C5BE",
    name: "Durvalumab",
  },
];
export const tmbmsipdlcolors = ["#27184A", "#EB455F", "#5D5277"];
export const TmbColor = [
  {
    code: "#EB455F",
    name: "High",
  },
  {
    code: "#5D5277",
    name: "Low",
  },
  {
    code: "#27184A",
    name: "Not Tested",
  },
];
export const MsiColor = [
  {
    code: "#5D5277",
    name: "Unstable",
  },
  {
    code: "#EB455F",
    name: "Stable",
  },
  {
    code: "#27184A",
    name: "NULL",
  },
];
export const PDLColor = [
  {
    code: "#BAD7E9",
    name: "Negative",
  },
  {
    code: "#EB455F",
    name: "Positive",
  },
  {
    code: "#323D7B",
    name: "NULL",
  },
];

export const TreatmentColor = [
  {
    code: "#EB455F",
    name: "Surgery",
  },
  {
    code: "#BAD7E9",
    name: "Radiation",
  },
  {
    code: "#323D7B",
    name: "Drugs Therapy",
  },
];
export const BiologicalColor = [
  {
    code: "#EB455F",
    name: "Immunotherapy",
  },
  {
    code: "#323D7B",
    name: "Targeted therapy",
  },
];
export const DrugColor = [
  {
    code: "#EB455F",
    name: "Chemo Therapy",
  },
  {
    code: "#BAD7E9",
    name: "Immuno Therapy",
  },
  {
    code: "#323D7B",
    name: "Hormonal Therapy",
  },
];

export const colorMapping = {
  Lung: "#a9a9a9",
  Breast: "#ff69b4",
  "Large Intestine": "#71F170",
  Brain: "#696969",
  Rectum: "#00D7E8",
  Esophagus: "#0000ff",
  Stomach: "#4169e1",
  Ovary: "#006994",
  "Unknown primary": "#ab4e52",
  "Other parts of tongue": "#8b0000",
  Gallbladder: "#32cd32",
  Skin: "#4D4545",
  Kidney: "#c46210",
  "Other and unspecified parts of mouth": "#ff0000",
  "Cervix Uteri": "#EB455F",
  "Other ill defined sites": "#008178",
  "Liver and intrahepatic bile ducts": "#008000",
  "Other and unspecified biliary tract": "#c30b4e",
  Pancreas: "#9400d3",
  "Corpus Uteri": "#FF8B8B",
  "Urinary Bladder": "#367588",
  Prostate: "#1e90ff",
  "Small Intestine": "#BAF660",
  "Rectosigmoid junction": "#F473B9",
  Thyroid: "#6495ed",
  "Other and unspecified major salivary gland": "#dc143c",
  "Connective, subcutaneous and other soft tissues": "#cd853f",
  Larynx: "#8b4513",
  Ureter: "#008b8b",
  Hypopharynx: "#009698",
  "Bones, joints, and articular cartilage of the limb": "#002147",
  Uterus: "#ffdab9",
  Oropharynx: "#722f37",
  "Renal pelvis": "#022E57",
  Lip: "#ffa500",
  "Intestinal tract": "#DFF6FF",
  "Anus and Anal canal": "#967117",
  "Parotid gland": "#2FA4FF",
  Nasopharynx: "#F9A11A",
  Palate: "#f94d00",
  "Accessory sinuses": "0E3EDA",
  "Other and ill-defined sites in lip, oral cavity and pharynx": "#5D8BF4",
  "Cerebral Meninges": "#276678",
  "Retroperitoneum and Peritoneum": "#7071F1",
  "Nasal cavity and middle ear": "#E2F91A",
  Testis: "#EB4747",
  "Fallopian tube and other regions": "#F9311A",
  Heart: "#FFDDEE",
  Vagina: "#F69C60",
  Lymphnode: "#32cd32",
  "Floor of mouth": "#FFB300",
  "Adrenal gland": "#F17071",
  "Other and unspecified urinary organs": "#ABC9FF",
  Thymus: "#00FFDD",
  Gum: "#E8FFC2",
  Eye: "#0096AA",
  "Pyriform sinus": "#FF8FCF",
  "Base of Tongue": "#B5ECFE",
  Penis: "#0D3B66",
  Tonsil: "#57205F",
  "Other endocrine glands": "#FF7D00",
  "Bones, joints and articular cartilage of other/ unspecified sites":
    "#034078",
};


export const LandingImages = {
  Venezuela: "assets/landing/Venezuela (1).svg",
  Bangladesh: "assets/landing/bangladesh1.svg",
  Turkey: "assets/landing/Turkey1.svg",
  Philippines: "assets/landing/Philippines1.svg",
  India: "assets/landing/India1.svg",
  Nepal: "assets/landing/Nepal.svg",
  SriLanka: "assets/landing/SriLanka.svg",
  Argentina: "assets/landing/Argentina.svg",
  CostaRica: "assets/landing/CostaRica.svg",
  Malaysia: "assets/landing/Malaysia.svg",
  UAE: "assets/landing/UAE.svg",
  USA: "assets/landing/USA.svg",
  Mexico: "assets/landing/Mexico.svg",
  Peru: "assets/landing/Peru.svg",
  Panama: "assets/landing/Panama.svg",
  Uzbekistan: "assets/landing/Uzbekistan.svg",
  Iran: "assets/landing/Iran.svg",
  Russia: "assets/landing/Russia.svg",
  banner: "assets/landing/Background_Map_Image_New.svg",
  gcdaLogo : "assets/landing/GCDA-big_logo.svg"
};
